$(function () {
    var scrollTop = 0;
    $(".right-content>ul>li>a").click(function () {
        var clickId = $(this).attr("id");
        $('html,body').animate({
            scrollTop: $('.' + clickId.toLowerCase()).offset().top
        }, 'fast');
    });
    $(window).scrollTop(0);
    $(window).scroll(function () {
        scrollTop = $(window).scrollTop();
        $('.counter').html(scrollTop);
        if (scrollTop >= 50) {
            $('.navbar-top').addClass('scrolled-nav');
        } else if (scrollTop < 50) {
            $('.navbar-top').removeClass('scrolled-nav');
        }
    });
});


// WEBPACK FOOTER //
// ./src/assets/js/landing/landing_center.js